







import { Component, Prop, Vue } from "vue-property-decorator";

import iScalerItem from "./i-scaler-item.vue";

interface IScalerDatas {
  type: string;
  data: any;
}

@Component({
  components: {
    iScalerItem
  }
})
export default class iScaler extends Vue {
  @Prop({
    default: true
  })
  datas?: IScalerDatas;

  private openScaler() {
    this.$bus.$emit("open-viewer", this.datas, this.$refs.scaler);
  }
}
